<!-- 拼版规则 -->
<template>
  <BaseFormItem2
    unit="Pcs"
    class="layout"
    :label="fields.label"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <BaseInput2
      v-model="val.layoutx"
      width="65px"
      placeholder="横片数量"
      :isError="isError"
      :disabled="disabled"
      @input="val => handleEmit('layoutx')"
      @change="handleEmitChange"
    ></BaseInput2>
    <span class="layout__linker">x</span>
    <BaseInput2
      v-model="val.layouty"
      width="65px"
      placeholder="纵片数量"
      :isError="isError"
      :disabled="disabled"
      @input="val => handleEmit('layouty')"
      @change="handleEmitChange"
    ></BaseInput2>
    <span slot="other">
      （拼版后尺寸：{{ exampleData.setlength || 0 }}*{{ exampleData.setwidth || 0 }}cm）
    </span>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    layoutx: {
      type: [String, Number],
      default: ''
    },
    layouty: {
      type: [String, Number],
      default: ''
    },
    exampleData: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: {
        layoutx: this.layoutx,
        layouty: this.layouty
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('layout')
    },
    // 是否显示未填写样式
    fillTips() {
      const { layoutx, layouty } = this.val
      return !layoutx && !layouty
    }
  },
  watch: {
    layoutx(layoutx) {
      this.val.layoutx = layoutx
    },
    layouty(layouty) {
      this.val.layouty = layouty
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      const { layoutx, layouty } = this.val
      this.$emit('change', { layoutx, layouty })
      this.isShowError(false)
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
.layout {
  .layout__linker {
    margin: 0 8px;
    color: #BBBBBB;
  }
}
</style>